const NOT_FOR_SALE_STATUSES = [ 'for_rent', 'not_for_sale' ];

export const getPageName = () => {
  const propStatus = getPropStatus();
  const viewType = getViewType();
  if (!viewType) { return viewType }
  return `${propStatus}:${viewType}`;
};

export const getPropStatus = () => {
  const propStatus = MOVE_DATA.adobeDTM.propertyStatus;
  return NOT_FOR_SALE_STATUSES.indexOf(propStatus) >=0 ? propStatus : `for_sale`;
};

export const getViewType = () => {
  const pageType = MOVE_DATA.adobeDTM.pageType;
  const viewType = pageType === 'srp-list' ? 'list' : pageType === 'srp-map' ? 'map' : '';
  if (!viewType) { return viewType }
  return `srp_${viewType}`;
};

export const getSiteSection = (propertyStatus) => {
  return NOT_FOR_SALE_STATUSES.indexOf(propertyStatus) >= 0 ? propertyStatus : 'for_sale';
};



// WEBPACK FOOTER //
// ./shared_critical/tracking/pages/srp/srp_tracking_helper.js